(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["fdc3"] = factory();
	else
		root["fdc3"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
const openfin_service_signal_1 = __webpack_require__(13);
const errors_1 = __webpack_require__(5);
/**
 * The identity of the main application window of the service provider
 */
const serviceIdentity = {
    uuid: 'fdc3-service',
    name: 'fdc3-service'
};
/**
 * Name of the IAB channel use to communicate between client and provider
 */
let serviceChannel = 'of-fdc3-service-v1';
/**
 * Event fired when the channel to the provider has been re-established.
 */
exports.onReconnect = new openfin_service_signal_1.Signal();
/**
 * ID of the channel all windows are placed in by default when first created
 */
exports.DEFAULT_CHANNEL_ID = 'default';
/**
 * Enum containing all and only actions that the provider can accept.
 */
var APIFromClientTopic;
(function (APIFromClientTopic) {
    APIFromClientTopic["OPEN"] = "OPEN";
    APIFromClientTopic["FIND_INTENT"] = "FIND-INTENT";
    APIFromClientTopic["FIND_INTENTS_BY_CONTEXT"] = "FIND-INTENTS-BY-CONTEXT";
    APIFromClientTopic["BROADCAST"] = "BROADCAST";
    APIFromClientTopic["RAISE_INTENT"] = "RAISE-INTENT";
    APIFromClientTopic["ADD_INTENT_LISTENER"] = "ADD-INTENT-LISTENER";
    APIFromClientTopic["REMOVE_INTENT_LISTENER"] = "REMOVE-INTENT-LISTENER";
    APIFromClientTopic["ADD_CONTEXT_LISTENER"] = "ADD-CONTEXT-LISTENER";
    APIFromClientTopic["REMOVE_CONTEXT_LISTENER"] = "REMOVE-CONTEXT-LISTENER";
    APIFromClientTopic["GET_SYSTEM_CHANNELS"] = "GET-SYSTEM-CHANNELS";
    APIFromClientTopic["GET_CHANNEL_BY_ID"] = "GET-CHANNEL-BY-ID";
    APIFromClientTopic["GET_CURRENT_CHANNEL"] = "GET-CURRENT-CHANNEL";
    APIFromClientTopic["GET_OR_CREATE_APP_CHANNEL"] = "GET-OR-CREATE-APP-CHANNEL";
    APIFromClientTopic["CHANNEL_GET_MEMBERS"] = "CHANNEL-GET-MEMBERS";
    APIFromClientTopic["CHANNEL_JOIN"] = "CHANNEL-JOIN";
    APIFromClientTopic["CHANNEL_BROADCAST"] = "CHANNEL-BROADCAST";
    APIFromClientTopic["CHANNEL_GET_CURRENT_CONTEXT"] = "CHANNEL-GET-CURRENT-CONTEXT";
    APIFromClientTopic["CHANNEL_ADD_CONTEXT_LISTENER"] = "CHANNEL-ADD-CONTEXT-LISTENER";
    APIFromClientTopic["CHANNEL_REMOVE_CONTEXT_LISTENER"] = "CHANNEL-REMOVE-CONTEXT-LISTENER";
    APIFromClientTopic["CHANNEL_ADD_EVENT_LISTENER"] = "CHANNEL-ADD-EVENT-LISTENER";
    APIFromClientTopic["CHANNEL_REMOVE_EVENT_LISTENER"] = "CHANNEL-REMOVE-EVENT-LISTENER";
})(APIFromClientTopic = exports.APIFromClientTopic || (exports.APIFromClientTopic = {}));
/**
 * Enum containing all and only actions that the client can accept.
 */
var APIToClientTopic;
(function (APIToClientTopic) {
    APIToClientTopic["RECEIVE_INTENT"] = "RECEIVE-INTENT";
    APIToClientTopic["RECEIVE_CONTEXT"] = "RECEIVE-CONTEXT";
    APIToClientTopic["CHANNEL_RECEIVE_CONTEXT"] = "CHANNEL-RECEIVE-CONTEXT";
})(APIToClientTopic = exports.APIToClientTopic || (exports.APIToClientTopic = {}));
/**
 * Invokes an array of listeners with a given context, allowing us to apply consistent error handling. Will throw an error if > 0 listeners are given, and all
 * fail. Otherwise the first *defined* value returned is returned, or undefined is no defined values are returned.
 *
 * @param listeners An array of listeners to invoke
 * @param context The context to invoke the listeners with
 * @param singleFailureHandler A function that will be called each time a listener throws an exception
 * @param createAllFailuresError A function that will be called if all (and more than one) listeners fail.
 * Should return an error, which `invokeListeners` will then throw.
 */
async function invokeListeners(listeners, context, singleFailureHandler, createAllFailuresError) {
    let successes = 0;
    let failures = 0;
    const result = await new Promise(async (resolve) => {
        await Promise.all(listeners.map(async (listener) => {
            try {
                const value = await listener.handler(context);
                successes++;
                if (value !== undefined) {
                    resolve(value);
                }
            }
            catch (e) {
                failures++;
                singleFailureHandler(e);
            }
        }));
        resolve(undefined);
    });
    if (failures > 0 && successes === 0) {
        throw createAllFailuresError();
    }
    return result;
}
exports.invokeListeners = invokeListeners;
/**
 * If error is a type we explicitly handle (e.g., `TypeError`, `FDC3Error`) so it can be identified as the correct type at the client's end. Otherwise return
 * the error itself.
 * @param error The error
 */
function serializeError(error) {
    if (error.name === 'FDC3Error') {
        return new Error(JSON.stringify({
            name: 'FDC3Error',
            code: error.code,
            message: error.message
        }));
    }
    else if (error.name === 'TypeError') {
        return new Error(JSON.stringify({
            name: 'TypeError',
            message: error.message
        }));
    }
    return error;
}
exports.serializeError = serializeError;
/**
 * Check if the error was a serialized error, and if so reconstruct as the correct type. Otherwise return the error itself.
 * @param error The error
 */
function deserializeError(error) {
    try {
        const errorData = JSON.parse(error.message);
        if (errorData && errorData.name) {
            if (errorData.name === 'FDC3Error') {
                return new errors_1.FDC3Error(errorData.code, errorData.message);
            }
            else if (errorData.name === 'TypeError') {
                return new TypeError(errorData.message);
            }
        }
    }
    catch (e) {
        // Payload wasn't a serialized JSON object
    }
    return error;
}
exports.deserializeError = deserializeError;
function getServiceChannel() {
    return serviceChannel;
}
exports.getServiceChannel = getServiceChannel;
function getServiceIdentity() {
    return serviceIdentity;
}
exports.getServiceIdentity = getServiceIdentity;
async function setServiceIdentity(runtimeVersion) {
    if (runtimeVersion === undefined) {
        const info = await fin.System.getRuntimeInfo();
        if (info.fdc3AppUuid && info.fdc3ChannelName) {
            serviceIdentity.uuid = info.fdc3AppUuid;
            serviceIdentity.name = info.fdc3AppUuid;
            serviceChannel = info.fdc3ChannelName;
        }
    }
    else if (runtimeVersion) {
        serviceIdentity.uuid += `-${runtimeVersion}`;
        serviceIdentity.name += `-${runtimeVersion}`;
        serviceChannel += `-${runtimeVersion}`;
    }
}
exports.setServiceIdentity = setServiceIdentity;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * File contains vars used to establish service connection between client and provider.
 *
 * These are separated out from 'internal.ts' as including these from provider code will cause the provider to connect
 * to itself.
 *
 * These types are a part of the client, but are not required by applications wishing to interact with the service.
 * This file is excluded from the public-facing TypeScript documentation.
 */
const events_1 = __webpack_require__(3);
const openfin_service_async_1 = __webpack_require__(11);
const internal_1 = __webpack_require__(0);
const EventRouter_1 = __webpack_require__(14);
/**
 * The event emitter to emit events received from the service.  All addEventListeners will tap into this.
 */
exports.eventEmitter = new events_1.EventEmitter();
let eventRouter;
function getEventRouter() {
    if (!eventRouter) {
        eventRouter = new EventRouter_1.EventRouter(exports.eventEmitter);
    }
    return eventRouter;
}
exports.getEventRouter = getEventRouter;
/**
 * Promise to the channel object that allows us to connect to the client
 */
let channelPromise = null;
const environmentInitialized = new openfin_service_async_1.DeferredPromise();
let hasDisconnectListener = false;
let reconnect = false;
if (typeof document !== 'undefined' && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        environmentInitialized.resolve();
    });
}
else {
    environmentInitialized.resolve();
}
if (typeof fin !== 'undefined') {
    getServicePromise();
}
async function getServicePromise() {
    await environmentInitialized.promise;
    if (!channelPromise) {
        if (typeof fin === 'undefined') {
            channelPromise = Promise.reject(new Error('fin is not defined. The openfin-fdc3 module is only intended for use in an OpenFin application.'));
        }
        else {
            channelPromise = new Promise(async (resolve, reject) => {
                await internal_1.setServiceIdentity();
                if (fin.Window.me.uuid === internal_1.getServiceIdentity().uuid && fin.Window.me.name === internal_1.getServiceIdentity().name) {
                    reject(new Error('Trying to connect to provider from provider'));
                }
                else {
                    let channel = null;
                    setTimeout(() => {
                        if (channel === null) {
                            console.warn('Taking a long time to connect to FDC3 service. Is the FDC3 service running?');
                        }
                    }, 5000);
                    channel = await fin.InterApplicationBus.Channel.connect(internal_1.getServiceChannel(), {
                        wait: true,
                        payload: { version: '0.2.1' }
                    });
                    // Register service listeners
                    channel.register('WARN', (payload) => console.warn(payload)); // tslint:disable-line:no-any
                    // Any unregistered action will simply return false
                    channel.setDefaultAction(() => false);
                    if (!hasDisconnectListener) {
                        channel.onDisconnection(() => {
                            console.warn('Disconnected from FDC3 service');
                            reconnect = true;
                            channelPromise = null;
                            setTimeout(() => {
                                console.log('Attempting to reconnect to FDC3 service');
                                getServicePromise();
                            }, 300);
                        });
                        hasDisconnectListener = true;
                    }
                    if (reconnect) {
                        internal_1.onReconnect.emit();
                        console.log('Reconnected to FDC3 service');
                    }
                    else {
                        console.log('Connected to FDC3 service');
                    }
                    resolve(channel);
                }
            });
        }
    }
    return channelPromise;
}
exports.getServicePromise = getServicePromise;
/**
 * Wrapper around service.dispatch to help with type checking
 *
 * @param action String identifying the call being made to the provider
 * @param payload Object containing additional arguments
 */
async function tryServiceDispatch(action, payload) {
    const channel = await getServicePromise();
    return channel.dispatch(action, payload)
        .catch((error) => {
        throw internal_1.deserializeError(error);
    });
}
exports.tryServiceDispatch = tryServiceDispatch;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
class DeferredPromise {
    constructor() {
        const promise = new Promise((res, rej) => {
            this._resolve = res;
            this._reject = rej;
        });
        this._promise = promise;
    }
    get promise() {
        return this._promise;
    }
    get resolve() {
        return this._resolve;
    }
    get reject() {
        return this._reject;
    }
}
exports.DeferredPromise = DeferredPromise;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Errors
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Errors related to launching or interacting with a particular application.
 */
var ApplicationError;
(function (ApplicationError) {
    /**
     * Indicates that an application of the provided name could not be found, either running or in the application directory.
     */
    ApplicationError["NotFound"] = "ApplicationError:NotFound";
    /**
     * Indicates that an application could not be started from an OpenFin manifest.
     */
    ApplicationError["LaunchError"] = "ApplicationError:LaunchError";
    /**
     * Indicates that a timeout was reached before the application was started.
     */
    ApplicationError["LaunchTimeout"] = "ApplicationError:LaunchTimeout";
})(ApplicationError = exports.ApplicationError || (exports.ApplicationError = {}));
/**
 * Error codes relating to the context channel system.
 */
var ChannelError;
(function (ChannelError) {
    /**
     * Indicates that a channel of a provided ID does not exist.
     */
    ChannelError["ChannelWithIdDoesNotExist"] = "ChannelError:ChannelWithIdDoesNotExist";
})(ChannelError = exports.ChannelError || (exports.ChannelError = {}));
/**
 * Error codes relating to connections to the FDC3 service, from OpenFin windows or otherwise.
 */
var ConnectionError;
(function (ConnectionError) {
    /**
     * Indicates that no window with a provided OpenFin Identity is registered with the FDC3 service.
     */
    ConnectionError["WindowWithIdentityNotFound"] = "ConnectionError:WindowWithIdentityNotFound";
})(ConnectionError = exports.ConnectionError || (exports.ConnectionError = {}));
/**
 * Errors related to resolving an application to handle an intent and context.
 */
var ResolveError;
(function (ResolveError) {
    /**
     * Indicates that no application could be found to handle the provided intent and context.
     */
    ResolveError["NoAppsFound"] = "ResolveError:NoAppsFound";
    /**
     * Indicates that a provided application does not handle the provided intent and context.
     */
    ResolveError["AppDoesNotHandleIntent"] = "ResolveError:AppDoesNotHandleIntent";
    /**
     * Indicates that intent resolution has been cancelled because the user dismissed the intent resolver UI.
     */
    ResolveError["ResolverClosedOrCancelled"] = "ResolveError:ResolverClosedOrCancelled";
})(ResolveError = exports.ResolveError || (exports.ResolveError = {}));
/**
 * Errors related to sending a context, possibly as part of an intent, to another application registered with the FDC3 service
 */
var SendContextError;
(function (SendContextError) {
    /**
     * Indicates that the target application has no windows that have a relevant handler for the given context.
     */
    SendContextError["NoHandler"] = "SendContextError:NoHandler";
    /**
     * Indicates that all handlers for the given context threw an error when invoked.
     */
    SendContextError["HandlerError"] = "SendContextError:HandlerError";
    /**
     * Indicates that all handers for the given context failed to completed before a timeout was reached
     */
    SendContextError["HandlerTimeout"] = "SendContextError:SendIntentTimeout";
})(SendContextError = exports.SendContextError || (exports.SendContextError = {}));
/**
 * Class used to hold errors returned by the FDC3 provider. Inherits from the built-in
 * [Error](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error) type.
 *
 * Note that not all errors raised by the service will be of type `FDC3Error`. Standard JavaScript error types such as
 * `TypeError` and `Error` can also be thrown by the API.
 */
class FDC3Error extends Error {
    constructor(code, message) {
        super(message);
        this.name = 'FDC3Error';
        this.code = code;
    }
}
exports.FDC3Error = FDC3Error;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @hidden
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates the provided Identity and returns an Identity stripped of any extraneous properties
 */
function parseIdentity(identity) {
    let error = false;
    if (identity === null || typeof identity !== 'object') {
        error = true;
    }
    else {
        const uuidCheck = typeof identity.uuid === 'string';
        const nameCheck = !identity.name || typeof identity.name === 'string';
        if (!uuidCheck || !nameCheck) {
            error = true;
        }
    }
    if (error) {
        throw new TypeError(`${safeStringify(identity, 'The provided Identity')} is not a valid Identity`);
    }
    return { uuid: identity.uuid, name: identity.name || identity.uuid };
}
exports.parseIdentity = parseIdentity;
/**
 * Validates the provided Context. No properties are stripped, as these are permitted by the FDC3 specification
 */
function parseContext(context) {
    let error = false;
    if (context === null || typeof context !== 'object') {
        error = true;
    }
    else {
        const typeCheck = typeof context.type === 'string';
        const nameCheck = !context.name || typeof context.name === 'string';
        const idCheck = !context.id || typeof context.id === 'object';
        if (!typeCheck || !nameCheck || !idCheck) {
            error = true;
        }
    }
    if (error) {
        throw new TypeError(`${safeStringify(context, 'The provided Context')} is not a valid Context`);
    }
    return context;
}
exports.parseContext = parseContext;
/**
 * Validates the provided ChannelId
 */
function parseChannelId(channelId) {
    if (typeof channelId !== 'string') {
        throw new TypeError(`${safeStringify(channelId, 'The provided ChannelId')} is not a valid ChannelId`);
    }
    return channelId;
}
exports.parseChannelId = parseChannelId;
/**
 * Validates the provided app channel name
 */
function parseAppChannelName(name) {
    if (typeof name !== 'string' || name === '') {
        throw new TypeError(`${safeStringify(name, 'The provided app channel name')} is not a valid app channel name`);
    }
    return name;
}
exports.parseAppChannelName = parseAppChannelName;
/**
 * Validates we're running inside an OpenFin environment
 */
function validateEnvironment() {
    if (typeof fin === 'undefined') {
        throw new Error('fin is not defined. The openfin-fdc3 module is only intended for use in an OpenFin application.');
    }
}
exports.validateEnvironment = validateEnvironment;
function safeStringify(value, fallback) {
    // Provided object may not be stringify-able (e.g., due to circular references), so we need to try-catch
    let result;
    try {
        result = JSON.stringify(value);
    }
    catch (e) {
        result = fallback;
    }
    return result;
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {
/**
 * @module Index
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Main entry point
 */
const connection_1 = __webpack_require__(2);
const internal_1 = __webpack_require__(0);
const validation_1 = __webpack_require__(6);
/**
 * This file was copied from the FDC3 v1 specification.
 *
 * Original file: https://github.com/FDC3/FDC3/blob/master/src/api/interface.ts
 */
// Re-export context channel API at top-level
__export(__webpack_require__(15));
// Re-export types/enums at top-level
__export(__webpack_require__(16));
__export(__webpack_require__(17));
__export(__webpack_require__(18));
__export(__webpack_require__(5));
const intentListeners = [];
const contextListeners = [];
/**
 * A desktop agent is a desktop component (or aggregate of components) that serves as a
 * launcher and message router (broker) for applications in its domain.
 *
 * A desktop agent can be connected to one or more App Directories and will use directories for application
 * identity and discovery. Typically, a desktop agent will contain the proprietary logic of
 * a given platform, handling functionality like explicit application interop workflows where
 * security, consistency, and implementation requirements are proprietary.
 */
/**
 * Launches/links to an app by name. The application will be started if it is not already running.
 *
 * If a [[Context]] object is passed in, this object will be provided to the opened application via a [[ContextListener]].
 *
 * If opening errors, it returns an [[FDC3Error]] with a string from the [[ApplicationError]] export enumeration.
 *
 * ```javascript
 *     // No context
 *     agent.open('myApp');
 *     // With context
 *     agent.open('myApp', context);
 * ```
 * @param name The [[AppName]] to launch.
 * @param context A context to pass to the app post-launch.
 * @throws [[FDC3Error]] with an [[ApplicationError]] code.
 * @throws If `context` is passed, [[FDC3Error]] with a [[SendContextError]] code.
 * @throws If `context` is passed, `TypeError` if `context` is not a valid [[Context]].
 */
async function open(name, context) {
    return connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.OPEN, { name, context: context && validation_1.parseContext(context) });
}
exports.open = open;
/**
 * Find out more information about a particular intent by passing its name, and optionally its context.
 *
 * `findIntent` is effectively granting programmatic access to the desktop agent's resolver.
 * A promise resolving to the intent, its metadata and metadata about the apps registered to handle it is returned.
 * This can be used to raise the intent against a specific app.
 *
 * For example, I know `'StartChat'` exists as a concept, and want to know more about it.
 * ```javascript
 * const appIntent = await agent.findIntent("StartChat");
 * ```
 *
 * This returns a single [[AppIntent]] (some fields omitted for brevity, see [[Application]] for full list of `apps` fields):
 * ```ts
 * {
 *      intent: { name: "StartChat", displayName: "Chat" },
 *      apps: [{ name: "Skype" }, { name: "Symphony" }, { name: "Slack" }]
 * }
 * ```
 *
 * We can then raise the intent against a particular app
 * ```javascript
 * await agent.raiseIntent(appIntent.intent.name, context, appIntent.apps[0].name);
 * ```
 * @param intent The intent name to find.
 * @param context An optional context to send to find the intent.
 * @throws If `context` is passed, an [[FDC3Error]] with a [[SendContextError]] code.
 * @throws If `context` is passed, `TypeError` if `context` is not a valid [[Context]].
 */
async function findIntent(intent, context) {
    return connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.FIND_INTENT, { intent, context: context && validation_1.parseContext(context) });
}
exports.findIntent = findIntent;
/**
 * Find all the available intents for a particular context.
 *
 * `findIntentsByContext` is effectively granting programmatic access to the desktop agent's resolver.
 * A promise resolving to all the intents, their metadata and metadata about the apps registered to handle it is
 * returned, based on the context export types the intents have registered.
 *
 * An empty array will be returned if there are no available intents for the given context.
 *
 * For example, I have a context object and I want to know what I can do with it, so I look for intents...
 * ```javascript
 * const appIntents = await agent.findIntentsByContext(context);
 * ```
 * This returns an array of [[AppIntent]] objects such as the following (some fields omitted for brevity, see
 * [[Application]] for full list of `apps` fields):
 * ```ts
 * [
 *    {
 *       intent: { name: "StartCall", displayName: "Call" },
 *       apps: [{ name: "Skype" }]
 *   },
 *   {
 *       intent: { name: "StartChat", displayName: "Chat" },
 *       apps: [{ name: "Skype" }, { name: "Symphony" }, { name: "Slack" }]
 *   }
 * ]
 * ```
 *
 * We could now use this by taking one of the intents, and raising it.
 * ```javascript
 * // Select a particular intent to raise
 * const selectedIntent = appIntents[1];
 *
 * // Raise the intent, passing the given context, letting the user select which app to use
 * await agent.raiseIntent(selectedIntent.intent.name, context);
 *
 * // Raise the intent, passing the given context, targeting a particular app
 * const selectedApp = selectedIntent.apps[0];
 * await agent.raiseIntent(selectedIntent.intent.name, context, selectedApp.name);
 * ```
 * @param context Returned intents must support this context.
 * @throws [[FDC3Error]] with a [[SendContextError]] code.
 * @throws `TypeError` if `context` is not a valid [[Context]].
 */
async function findIntentsByContext(context) {
    return connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.FIND_INTENTS_BY_CONTEXT, { context: validation_1.parseContext(context) });
}
exports.findIntentsByContext = findIntentsByContext;
/**
 * Publishes context to other apps on the desktop. Any apps using [[addContextListener]] will receive this.
 * ```javascript
 *  agent.broadcast(context);
 * ```
 *
 * Only windows in the same [[ChannelBase|channel]] as the broadcasting window will receive the context. All windows
 * will initially be in the same channel (referred to as the [[defaultChannel|default channel]]). See
 * [[ContextChannels]] for more details.
 *
 * Note that windows do not receive their own broadcasts. If the window calling `broadcast` has also added one or more
 * [[addContextListener|context listeners]], then those listeners will not fire as a result of this broadcast.
 *
 * @param context The context to broadcast.
 * @throws `TypeError` if `context` is not a valid [[Context]].
 */
async function broadcast(context) {
    await connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.BROADCAST, { context: validation_1.parseContext(context) });
}
exports.broadcast = broadcast;
/**
 * Raises an intent to the desktop agent to resolve. Intents can be either targeted or non-targeted, determined by the
 * presence or absense of the `target` argument. For non-targeted intents, the service will search the directory and
 * any running applications to find an application that can handle the given intent and context. If there are multiple
 * such applications, the end user will be asked to select which application they wish to use.
 *
 * If the application isn't already running, it will be started by the service. The intent data will then be passed to
 * the target application's intent listener. The promise returned by this function resolves when the service has
 * confirmed that the target application has been started its intent listener has completed successfully.
 *
 * The returned [[IntentResolution]] object indicates which application handled the intent (if the intent is a targeted
 * intent, this will always be the value passed as `target`), and contains the data returned by the target applications
 * intent listener (if any).
 *
 * ```javascript
 * // Raise an intent to start a chat with a given contact
 * const intentR = await agent.raiseIntent("StartChat", context);
 * // Use the IntentResolution object to target the same chat app with a new context
 * agent.raiseIntent("StartChat", newContext, intentR.source);
 * ```
 * @param intent The intent name to raise.
 * @param context The context that will be sent with this intent.
 * @param target An optional [[AppName]] to send the intent to.
 * @throws [[FDC3Error]] with a [[ResolveError]] code.
 * @throws [[FDC3Error]] with an [[ApplicationError]] code.
 * @throws [[FDC3Error]] with a [[SendContextError]] code.
 * @throws `TypeError` if `context` is not a valid [[Context]].
 */
async function raiseIntent(intent, context, target) {
    return connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.RAISE_INTENT, { intent, context: validation_1.parseContext(context), target });
}
exports.raiseIntent = raiseIntent;
/**
 * Adds a listener for incoming intents from the Agent.
 *
 * If the handler function returns a defined value, this value will be returned to the caller of [[raiseIntent]] in
 * the `data` property of the [[IntentResolution]] object. If the value returned by the handler is a Promise, this
 * will be resolved before passing to the [[raiseIntent]] caller. If multiple handlers are registered by a target
 * application for a given intent, the fist defined return value to be returned and resolved (if a Promise) will be used.
 *
 * To unsubscribe, use the returned [[IntentListener]].
 *
 * @param intent The name of the intent to listen for.
 * @param handler The handler to call when we get sent an intent.
 */
function addIntentListener(intent, handler) {
    validation_1.validateEnvironment();
    const listener = {
        intent,
        handler,
        unsubscribe: () => {
            const index = intentListeners.indexOf(listener);
            if (index >= 0) {
                intentListeners.splice(index, 1);
                if (!hasIntentListener(intent)) {
                    connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.REMOVE_INTENT_LISTENER, { intent });
                }
            }
            return index >= 0;
        }
    };
    const hasIntentListenerBefore = hasIntentListener(intent);
    intentListeners.push(listener);
    if (!hasIntentListenerBefore) {
        connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.ADD_INTENT_LISTENER, { intent });
    }
    return listener;
}
exports.addIntentListener = addIntentListener;
/**
 * Adds a listener for incoming context broadcasts from the desktop agent.
 *
 * To unsubscribe, use the returned [[ContextListener]].
 * @param handler The handler function to call when we receive a broadcast context.
 */
function addContextListener(handler) {
    validation_1.validateEnvironment();
    const listener = {
        handler,
        unsubscribe: () => {
            const index = contextListeners.indexOf(listener);
            if (index >= 0) {
                contextListeners.splice(index, 1);
                if (contextListeners.length === 0) {
                    connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.REMOVE_CONTEXT_LISTENER, {});
                }
            }
            return index >= 0;
        }
    };
    const hasContextListenerBefore = contextListeners.length > 0;
    contextListeners.push(listener);
    if (!hasContextListenerBefore) {
        connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.ADD_CONTEXT_LISTENER, {});
    }
    return listener;
}
exports.addContextListener = addContextListener;
/**
 * Subscribes to a particular event. This is not for intent or context subscription: use [[addIntentListener]] and [[addContextListener]], respectively.
 * This is used for events that are global to the service, rather than limited to an intent or a context. Currently only takes the
 * channel change event.
 *
 * See also [[ChannelBase.addEventListener]], for subscribing to events of a particular context channel.
 *
 * @param eventType The event type.
 * @param handler The handler to call when the event is fired.
 */
function addEventListener(eventType, handler) {
    validation_1.validateEnvironment();
    connection_1.eventEmitter.addListener(eventType, handler);
}
exports.addEventListener = addEventListener;
/**
 * Unsubscribes from a particular event.
 *
 * Has no effect if `eventType` isn't a valid event, or `listener` isn't a handler registered against `eventType`.
 *
 * @param eventType The type of the event to remove.
 * @param handler The handler previously passed into [[addEventListener]].
 */
function removeEventListener(eventType, handler) {
    validation_1.validateEnvironment();
    connection_1.eventEmitter.removeListener(eventType, handler);
}
exports.removeEventListener = removeEventListener;
/**
 * Whether we are listening to a particular intent.
 * @param intent The intent.
 */
function hasIntentListener(intent) {
    return intentListeners.some((intentListener) => intentListener.intent === intent);
}
if (typeof fin !== 'undefined') {
    const eventHandler = connection_1.getEventRouter();
    eventHandler.registerEmitterProvider('main', () => connection_1.eventEmitter);
    internal_1.onReconnect.add(async () => {
        await initialize();
        await rehydrate();
    });
    setImmediate(() => {
        initialize();
    });
}
async function initialize() {
    const channelClient = await connection_1.getServicePromise();
    try {
        channelClient.register(internal_1.APIToClientTopic.RECEIVE_INTENT, async (payload) => {
            const result = await internal_1.invokeListeners(intentListeners.filter((listener) => payload.intent === listener.intent), payload.context, (e) => console.warn(`Error thrown by ${payload.intent} intent handler, swallowing error. Error message: ${e.message}`), () => new Error(`All ${payload.intent} intent handlers failed`));
            return result;
        });
        channelClient.register(internal_1.APIToClientTopic.RECEIVE_CONTEXT, async (payload) => {
            await internal_1.invokeListeners(contextListeners, payload.context, (e) => console.warn(`Error thrown by context handler, swallowing error. Error message: ${e.message}`), () => new Error('All context handlers failed'));
        });
        channelClient.register('event', (eventTransport) => {
            try {
                connection_1.getEventRouter().dispatchEvent(eventTransport);
            }
            catch (e) {
                console.warn(`Error thrown dispatching ${eventTransport.type} event, rethrowing error. Error message: ${e.message}`);
                throw e;
            }
        });
    }
    catch (e) {
        // Trying to subscribe the same topic
    }
}
async function rehydrate() {
    const intents = intentListeners.map(async ({ intent }) => connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.ADD_INTENT_LISTENER, { intent }));
    const contexts = contextListeners.map(async () => connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.ADD_CONTEXT_LISTENER, {}));
    await Promise.all([...intents, ...contexts]);
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(8).setImmediate))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(9);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(1)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(1), __webpack_require__(10)))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(12));
__export(__webpack_require__(4));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const DeferredPromise_1 = __webpack_require__(4);
async function serialForEach(arr, asyncF) {
    let i = 0;
    for (const x of arr) {
        await asyncF(x, i, arr);
        i++;
    }
}
exports.serialForEach = serialForEach;
async function serialMap(arr, asyncF) {
    const result = [];
    await serialForEach(arr, async (x, i, r) => {
        result.push(await asyncF(x, i, r));
    });
    return result;
}
exports.serialMap = serialMap;
async function serialFilter(arr, asyncF) {
    const result = [];
    await serialForEach(arr, async (x, i, r) => {
        if (await asyncF(x, i, r)) {
            result.push(x);
        }
    });
    return result;
}
exports.serialFilter = serialFilter;
async function parallelForEach(arr, asyncF) {
    await Promise.all(arr.map(asyncF));
}
exports.parallelForEach = parallelForEach;
async function parallelMap(arr, asyncF) {
    const result = [];
    await parallelForEach(arr, async (x, i, r) => {
        result[i] = await asyncF(x, i, r);
    });
    return result;
}
exports.parallelMap = parallelMap;
async function parallelFilter(arr, asyncF) {
    const table = [];
    await parallelForEach(arr, async (x, i, r) => {
        table[i] = await asyncF(x, i, r);
    });
    return arr.filter((x, i) => table[i]);
}
exports.parallelFilter = parallelFilter;
/**
 * Races a given promise against a timeout, and either resolves to the value the the promise resolved it, if it resolved before the
 * timeout, or rejects.
 *
 * @param timeoutMs Timeout period in ms
 * @param promise Promise to race against the timeout
 */
function withStrictTimeout(timeoutMs, promise, rejectMessage) {
    const timeout = new Promise((res, rej) => setTimeout(() => rej(new Error(rejectMessage)), timeoutMs));
    return allowReject(Promise.race([timeout, promise]));
}
exports.withStrictTimeout = withStrictTimeout;
/**
 * Races a given promise against a timeout, and resolves to a `[didTimeout, value?]` tuple indicating
 * whether the timeout occurred, and the value the promise resolved to (if timeout didn't occur).
 *
 * @param timeoutMs Timeout period in ms
 * @param promise Promise to race against the timeout
 */
function withTimeout(timeoutMs, promise) {
    const timeout = new Promise((res) => setTimeout(() => res([true, undefined]), timeoutMs));
    const p = promise.then((value) => [false, value]);
    return Promise.race([timeout, p]);
}
exports.withTimeout = withTimeout;
/**
 * Returns a promise that resolves when the given predicate is true, evaluated immediately and each time the provided signal is fired.
 *
 * @param signal When this signal is fired, the predicate is revaluated
 * @param predicate The predicate to evaluate
 * @param guard A promise. If this rejects, give up listening to the signal and reject
 */
function untilTrue(signal, predicate, guard) {
    if (predicate()) {
        return Promise.resolve();
    }
    return untilSignal(signal, predicate, guard);
}
exports.untilTrue = untilTrue;
/**
 * Returns a promise that resolves when the given signal is fired, and the given predicate evaluates to true when passed the arguments
 * recevied from the signal.
 *
 * @param signal The signal to listen to
 * @param predicate The predicate to evaluate against arguments received from the signal
 * @param guard A promise. If this rejects, give up listening to the signal and reject
 */
function untilSignal(signal, predicate, guard) {
    const promise = new DeferredPromise_1.DeferredPromise();
    const slot = signal.add((...args) => {
        if (predicate(...args)) {
            slot.remove();
            promise.resolve();
        }
    });
    if (guard) {
        guard.catch((e) => {
            slot.remove();
            promise.reject(e);
        });
    }
    return allowReject(promise.promise);
}
exports.untilSignal = untilSignal;
/**
 * Attaches an empty `catch` block to a promise, then returns the original promise. This prevents rejection of the promise being logged as
 * a warning during tests, but does not otherwise change behaviour should the promise reject. This should be called for promises we expect
 * to reject under normal circumstances, but would not otherwise have a `catch` block attached.
 *
 * @param promise The promise to attach the catch block to
 */
function allowReject(promise) {
    promise.catch(() => { });
    return promise;
}
exports.allowReject = allowReject;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A 'library' of common aggregators.
 *
 * Pass one of these functions to a `Signal[n]` constructor to add the described behaviour to that signal.
 */
class Aggregators {
    /**
     * Basic "pass-through" aggregator. Will pass an array of values back to the signal emitter, one per callback.
     *
     * Note that this means the size of the returned array depends on the number of listeners attached.
     */
    static ARRAY(items) {
        return items;
    }
    /**
     * If a signal allows listeners to return a promise, this aggregator will await all the received promises and then
     * return an array of the resolved values.
     *
     * This aggregator is intended for use with non-void promises, where the value returned by the promise is
     * meaningful. If the return value of the promise is not significant, consider {@link AwaitVoid}.
     */
    static AWAIT(items) {
        return Promise.all(items);
    }
    /**
     * An aggregator for use with Promise<void> signals. Will await all promises that are returned by callback
     * functions, but discard the (void) return values.
     */
    static async AWAIT_VOID(items) {
        await Promise.all(items);
    }
}
exports.Aggregators = Aggregators;
/**
 * Signal implementation, a messaging paradigm similar to standard JavaScript events, only more object-based.
 *
 * Create a signal for each event type, specifying the types of any callback parameters. Listeners (known as "slots")
 * can then be added to (and removed from) the signal.
 *
 * Unlike events, callbacks are also able to return a value. To make use of these return values, pass an aggregator
 * function when defining the signal. The static functions within {@link Aggregators} are a set of aggregators that
 * cover typical use-cases.
 */
class Signal {
    constructor(aggregator) {
        this._slots = [];
        this.aggregator = aggregator || null;
    }
    /**
     * Provides read-only access to the current set of slots.
     *
     * This is an array of all callbacks that are currently attached to this signal.
     */
    get slots() {
        return this._slots;
    }
    add(callback, context) {
        const slot = { callback, context, remove: () => this.removeSlot(slot) };
        this._slots.push(slot);
        return slot;
    }
    remove(callback, context) {
        const index = this._slots.findIndex((ctx) => ctx.callback === callback && ctx.context === context);
        if (index >= 0) {
            this._slots.splice(index, 1);
            return true;
        }
        else {
            return false;
        }
    }
    has(callback, context) {
        return this._slots.findIndex((ctx) => ctx.callback === callback && ctx.context === context) >= 0;
    }
    emit(...args) {
        const slots = this._slots.slice(); // Clone array, in case a callback modifies this signal
        if (!this.aggregator) {
            slots.forEach(slot => slot.callback.apply(slot.context, args));
            // If not using an aggregator, return type should be void.
            // No way to enforce this through TypeScript without creating a whole new set of signal classes, so relying on convention here.
            return undefined;
        }
        else {
            return this.aggregator(slots.map(slot => slot.callback.apply(slot.context, args)));
        }
    }
    removeSlot(slot) {
        const index = this._slots.indexOf(slot);
        if (index >= 0) {
            this._slots.splice(index, 1);
        }
    }
}
exports.Signal = Signal;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @hidden
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class for helping take events that have arrived at the client via the IAB channel, and dispatching them on the correct client-side object
 */
class EventRouter {
    constructor(defaultEmitter) {
        this._emitterProviders = {};
        this._deserializers = {};
        this._defaultEmitter = defaultEmitter;
    }
    registerEmitterProvider(targetType, emitterProvider) {
        this._emitterProviders[targetType] = emitterProvider;
    }
    registerDeserializer(eventType, deserializer) {
        this._deserializers[eventType] = deserializer;
    }
    dispatchEvent(event) {
        const { type, target } = event, rest = __rest(event, ["type", "target"]);
        let emitter;
        if (!target) {
            throw new Error('Invalid event, no target specified');
        }
        else if (target === 'default') {
            emitter = this._defaultEmitter;
        }
        else if (this._emitterProviders.hasOwnProperty(target.type)) {
            emitter = this._emitterProviders[target.type](target.id);
        }
        else {
            throw new Error(`Invalid target, no provider registered for '${target.type}'`);
        }
        // Need to remove 'target' from event before emitting event
        const inputEvent = Object.assign({ type }, rest);
        // Also run through any custom deserializer
        const deserializer = this._deserializers[type];
        if (deserializer) {
            emitter.emit(type, deserializer(inputEvent));
        }
        else {
            emitter.emit(type, inputEvent);
        }
    }
}
exports.EventRouter = EventRouter;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Context channels allow end-user filtering of context broadcasts. Each window is assigned to a particular
 * context channel, and any [[broadcast|broadcasts]] by any window in that channel will only be recevied by the other
 * windows in that channel. The assignment of windows to channels would typically be managed by the user, through
 * either a channel selector widget built into the window itself, or through a separate channel manager application.
 *
 * All windows will initially be placed in the [[defaultChannel|default channel]], and will remain there unless they
 * explicitly [[join]] another channel.
 *
 * There are three types of channels: [[DefaultChannel]], [[SystemChannel]] and [[AppChannel]].
 *
 * @module ContextChannels
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Contains API definitions for context channels
 */
/* eslint-disable no-dupe-class-members */
const events_1 = __webpack_require__(3);
const validation_1 = __webpack_require__(6);
const connection_1 = __webpack_require__(2);
const internal_1 = __webpack_require__(0);
/**
 * Class representing a context channel. All interactions with a context channel happen through the methods on here.
 *
 * When users wish to generically handle both {@link SystemChannel}s, {@link AppChannel}s and the
 * {@link DefaultChannel}, generally the {@link Channel} type should be used instead of {@link ChannelBase}.
 */
class ChannelBase {
    constructor(id, type) {
        this.id = id;
        this.type = type;
        channelEventEmitters[id] = new events_1.EventEmitter();
    }
    /**
     * Returns a list of all windows belonging to the specified channel.
     *
     * If the window making the call is a member of this channel, it will be included in the results. If there are no
     * windows on this channel, an empty array is returned.
     */
    async getMembers() {
        return connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.CHANNEL_GET_MEMBERS, { id: this.id });
    }
    /**
     * Returns the last context that was broadcast on this channel. All channels initially have no context, until a
     * window is added to the channel and then broadcasts. If there is not yet any context on the channel, this method
     * will return `null`. The context is also reset back into its initial context-less state whenever a channel is
     * cleared of all windows.
     *
     * The context of a channel will be captured regardless of how the context is broadcasted on this channel - whether
     * using the top-level FDC3 `broadcast` function, or using the channel-level {@link broadcast} function on this
     * object.
     *
     * NOTE: Only non-default channels are stateful, for the default channel this method will always return `null`.
     */
    async getCurrentContext() {
        return connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.CHANNEL_GET_CURRENT_CONTEXT, { id: this.id });
    }
    /**
     * Adds the given window to this channel. If no identity is provided, the window making the call will be the window
     * added to the channel.
     *
     * If the channel has a current context (see {@link getCurrentContext}) then that context will be immediately passed to
     * the given window upon joining the channel, via its context listener(s).
     *
     * Note that all windows will always belong to exactly one channel at all times. If you wish to leave a channel,
     * the only way to do so is to join another channel. A window may rejoin the default channel by calling `channels.defaultChannel.join()`.
     *
     * @param identity The window that should be added to this channel. If omitted, will use the window that calls this method.
     * @throws If `identity` is passed, [[FDC3Error]] with an [[ConnectionError]] code.
     * @throws If `identity` is passed, `TypeError` if `identity` is not a valid
     * {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
     */
    async join(identity) {
        return connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.CHANNEL_JOIN, { id: this.id, identity: identity && validation_1.parseIdentity(identity) });
    }
    /**
     * Broadcasts the given context on this channel.
     *
     * Note that this function can be used without first joining the channel, allowing applications to broadcast on
     * channels that they aren't a member of.
     *
     * This broadcast will be received by all windows that are members of this channel, *except* for the window that
     * makes the broadcast. This matches the behavior of the top-level FDC3 `broadcast` function.
     *
     * @param context The context to broadcast to all windows on this channel.
     * @throws `TypeError` if `context` is not a valid [[Context]].
     */
    async broadcast(context) {
        await connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.CHANNEL_BROADCAST, { id: this.id, context: validation_1.parseContext(context) });
    }
    /**
     * Event that is fired whenever a window broadcasts on this channel.
     *
     * This can be triggered by a window belonging to the channel calling the top-level FDC3 `broadcast` function, or by
     * any window calling this channel's {@link broadcast} method.
     *
     * @param handler Function that should be called whenever a context is broadcast on this channel.
     */
    addContextListener(handler) {
        validation_1.validateEnvironment();
        const listener = {
            channel: this,
            handler,
            unsubscribe: () => {
                const index = channelContextListeners.indexOf(listener);
                if (index >= 0) {
                    channelContextListeners.splice(index, 1);
                    if (!hasChannelContextListener(this.id)) {
                        connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.CHANNEL_REMOVE_CONTEXT_LISTENER, { id: this.id });
                    }
                }
                return index >= 0;
            }
        };
        const hasContextListenerBefore = hasChannelContextListener(this.id);
        channelContextListeners.push(listener);
        if (!hasContextListenerBefore) {
            connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.CHANNEL_ADD_CONTEXT_LISTENER, { id: this.id });
        }
        return listener;
    }
    /**
     * Subscribes to a particular event. This is not for subscribing to context updates on this channel. Instead, use
     * [[addContextListener]] to receive broadcasts. This is used for events that are raised from a specific channel.
     *
     * See also [[main#addEventListener]], for subscribing to "global" events that are not related to a specific channel.
     *
     * @param eventType The event type.
     * @param handler The handler to call when the event is fired.
     */
    addEventListener(eventType, handler) {
        validation_1.validateEnvironment();
        const hasEventListenerBefore = channelEventEmitters[this.id].listenerCount(eventType) > 0;
        channelEventEmitters[this.id].addListener(eventType, handler);
        if (!hasEventListenerBefore) {
            connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.CHANNEL_ADD_EVENT_LISTENER, { id: this.id, eventType });
        }
    }
    /**
     * Unsubscribes from a particular event.
     *
     * Has no effect if `eventType` isn't a valid event, or `handler` isn't a handler registered against `eventType`.
     *
     * @param eventType The event being unsubscribed from.
     * @param handler The handler function to remove.
     */
    removeEventListener(eventType, handler) {
        validation_1.validateEnvironment();
        channelEventEmitters[this.id].removeListener(eventType, handler);
        if (channelEventEmitters[this.id].listenerCount(eventType) === 0) {
            connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.CHANNEL_REMOVE_EVENT_LISTENER, { id: this.id, eventType });
        }
    }
}
exports.ChannelBase = ChannelBase;
/**
 * The channel all windows start in.
 *
 * Unlike system channels, the default channel has no pre-defined name or visual style. It is up to apps to display
 * this in the channel selector as they see fit - it could be as "default", or "none", or by "leaving" a user channel.
 *
 * An instance of the default channel is available from the [[defaultChannel]] getter API.
 */
class DefaultChannel extends ChannelBase {
    /**
     * @hidden
     *
     * Channel objects should not be created directly by an application, channel objects should be obtained by calling the relevant APIs.
     */
    constructor() {
        super(internal_1.DEFAULT_CHANNEL_ID, 'default');
    }
}
exports.DefaultChannel = DefaultChannel;
/**
 * User-facing channels, to display within a color picker or channel selector component.
 *
 * This list of channels should be considered fixed by applications - the service will own the list of user channels,
 * making the same list of channels available to all applications, and this list will not change over the lifecycle of
 * the service.
 *
 * To fetch the list of available channels, use [[getSystemChannels]].
 */
class SystemChannel extends ChannelBase {
    /**
     * @hidden
     *
     * Channel objects should not be created directly by an application, channel objects should be obtained by calling the relevant APIs.
     */
    constructor(transport) {
        super(transport.id, 'system');
        this.visualIdentity = transport.visualIdentity;
    }
}
exports.SystemChannel = SystemChannel;
/**
 * Custom application-created channels.
 *
 * Applications can create these for specialised use-cases.  These channels should be obtained by name by calling
 * {@link getOrCreateAppChannel} and it is up to your organization to decide how applications are aware of this name.
 * As with organization defined contexts, app channel names should have a prefix specific to your organization to avoid
 * name collisions, e.g. `'company-name.channel-name'`.
 *
 * App channels can be joined by any window, but are only indirectly discoverable if the name is not known.
 */
class AppChannel extends ChannelBase {
    /**
     * @hidden
     *
     * Channel objects should not be created directly by an application, channel objects should be obtained by calling the relevant APIs.
     */
    constructor(transport) {
        super(transport.id, 'app');
        this.name = transport.name;
    }
}
exports.AppChannel = AppChannel;
const channelEventEmitters = {};
/**
 * The channel in which all windows will initially be placed.
 *
 * All windows will belong to exactly one channel at all times. If they have not explicitly been placed into a channel
 * via a {@link ChannelBase.join} call, they will be in this channel.
 *
 * If an app wishes to leave any other channel, it can do so by (re-)joining this channel.
 */
exports.defaultChannel = new DefaultChannel();
const channelLookup = {
    [internal_1.DEFAULT_CHANNEL_ID]: exports.defaultChannel
};
const channelContextListeners = [];
/**
 * Gets all service-defined system channels.
 *
 * This is the list of channels that should be used to populate a channel selector. All channels returned will have
 * additional metadata that can be used to populate a selector UI with a consistent cross-app channel list.
 */
async function getSystemChannels() {
    const channelTransports = await connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.GET_SYSTEM_CHANNELS, {});
    return channelTransports.map(getChannelObject);
}
exports.getSystemChannels = getSystemChannels;
/**
 * Fetches a channel object for a given channel identifier. The `channelId` property maps to the {@link ChannelBase.id} field.
 *
 * @param channelId The ID of the channel to return
 * @throws [[FDC3Error]] with an [[ChannelError]] code.
 */
async function getChannelById(channelId) {
    const channelTransport = await connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.GET_CHANNEL_BY_ID, { id: validation_1.parseChannelId(channelId) });
    return getChannelObject(channelTransport);
}
exports.getChannelById = getChannelById;
/**
 * Returns the channel that the current window is assigned to.
 *
 * @param identity The window to query. If omitted, will use the window that calls this method.
 * @throws If `identity` is passed, [[FDC3Error]] with an [[ConnectionError]] code.
 * @throws If `identity` is passed, `TypeError` if `identity` is not a valid
 * {@link https://developer.openfin.co/docs/javascript/stable/global.html#Identity | Identity}.
 */
async function getCurrentChannel(identity) {
    const channelTransport = await connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.GET_CURRENT_CHANNEL, { identity: identity && validation_1.parseIdentity(identity) });
    return getChannelObject(channelTransport);
}
exports.getCurrentChannel = getCurrentChannel;
/**
 * Returns an app channel with the given name. Either creates a new channel or returns an existing channel.
 *
 * It is up to your organization to decide how to share knowledge of these custom channels. As with organization
 * defined contexts, app channel names should have a prefix specific to your organization to avoid name collisions,
 * e.g. `'company-name.channel-name'`.
 *
 * The service will assign a unique ID when creating a new app channel, but no particular mapping of name to ID should
 * be assumed.
 *
 * @param name The name of the channel. Must not be an empty string.
 * @throws `TypeError` if `name` is not a valid app channel name, i.e., a non-empty string.
 */
async function getOrCreateAppChannel(name) {
    const channelTransport = await connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.GET_OR_CREATE_APP_CHANNEL, { name: validation_1.parseAppChannelName(name) });
    return getChannelObject(channelTransport);
}
exports.getOrCreateAppChannel = getOrCreateAppChannel;
function getChannelObject(channelTransport) {
    let channel = channelLookup[channelTransport.id];
    if (!channel) {
        switch (channelTransport.type) {
            case 'default':
                channel = exports.defaultChannel;
                break;
            case 'system':
                channel = new SystemChannel(channelTransport);
                channelLookup[channelTransport.id] = channel;
                break;
            case 'app':
                channel = new AppChannel(channelTransport);
                channelLookup[channelTransport.id] = channel;
                break;
        }
    }
    return channel;
}
function hasChannelContextListener(id) {
    return channelContextListeners.some((listener) => listener.channel.id === id);
}
function deserializeWindowAddedEvent(eventTransport) {
    const identity = eventTransport.identity;
    const channel = getChannelObject(eventTransport.channel);
    const previousChannel = eventTransport.previousChannel ? getChannelObject(eventTransport.previousChannel) : null;
    return { type: 'window-added', identity, channel, previousChannel };
}
function deserializeWindowRemovedEvent(eventTransport) {
    const identity = eventTransport.identity;
    const channel = eventTransport.channel ? getChannelObject(eventTransport.channel) : null;
    const previousChannel = getChannelObject(eventTransport.previousChannel);
    return { type: 'window-removed', identity, channel, previousChannel };
}
// Keep track of the channel the client is in so it can be rejoined on disconnect
let currentChannel = null;
function deserializeChannelChangedEvent(eventTransport) {
    const type = eventTransport.type;
    const identity = eventTransport.identity;
    const channel = eventTransport.channel ? getChannelObject(eventTransport.channel) : null;
    const previousChannel = eventTransport.previousChannel ? getChannelObject(eventTransport.previousChannel) : null;
    if (fin.Window.me.name === identity.name && fin.Window.me.uuid === identity.uuid) {
        currentChannel = channel;
    }
    return { type, identity, channel, previousChannel };
}
if (typeof fin !== 'undefined') {
    const eventHandler = connection_1.getEventRouter();
    eventHandler.registerEmitterProvider('channel', (channelId) => {
        return channelEventEmitters[channelId];
    });
    eventHandler.registerDeserializer('channel-changed', deserializeChannelChangedEvent);
    eventHandler.registerDeserializer('window-added', deserializeWindowAddedEvent);
    eventHandler.registerDeserializer('window-removed', deserializeWindowRemovedEvent);
    internal_1.onReconnect.add(async () => {
        await initialize();
        await rehydrate();
    });
    initialize();
}
function initialize() {
    return connection_1.getServicePromise().then(async (channelClient) => {
        try {
            channelClient.register(internal_1.APIToClientTopic.CHANNEL_RECEIVE_CONTEXT, async (payload) => {
                await internal_1.invokeListeners(channelContextListeners.filter((listener) => listener.channel.id === payload.channel), payload.context, (e) => console.warn(`Error thrown by channel context handler, swallowing error. Error message: ${e.message}`), () => new Error('All channel context handlers failed'));
            });
        }
        catch (e) {
            // Trying to resubscribe to the same channel
        }
    }, (reason) => {
        console.warn('Unable to register client channel context handlers. getServicePromise() rejected with reason:', reason);
    });
}
async function rehydrate() {
    let channelToJoin = currentChannel || exports.defaultChannel;
    if (channelToJoin.type === 'app') {
        channelToJoin = await getOrCreateAppChannel(channelToJoin.name);
    }
    await channelToJoin.join();
    await Promise.all(channelContextListeners.map(({ channel }) => connection_1.tryServiceDispatch(internal_1.APIFromClientTopic.CHANNEL_ADD_CONTEXT_LISTENER, { id: channel.id })));
    currentChannel = channelToJoin;
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TypeScript definitions for context objects.
 *
 * These structures are defined by the Contexts FDC3 working group. This contains the Context interface for you to create your own
 * contexts, as well as a set of standard contexts agreed by the FDC3 working group.
 *
 * @module Contexts
 */
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * TypeScript definitions for objects returned by the Application Directory.
 *
 * These structures are defined by the App-Directory FDC3 working group. The definitions here are based on the 1.0.0
 * specification which can be found [here](https://fdc3.finos.org/appd-spec).
 *
 * @module Directory
 */
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Intents
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Enum that defines the standard set of intents that are defined as part of the FDC3 specification.
 *
 * This enum exists only as a helper, applications may define their own set of constants if they prefer.
 */
var Intents;
(function (Intents) {
    Intents["DIAL_CALL"] = "DialCall";
    Intents["SAVE_CONTACT"] = "SaveContact";
    Intents["SAVE_INSTRUMENT"] = "SaveInstrument";
    Intents["SHARE_CONTEXT"] = "ShareContext";
    Intents["START_CALL"] = "StartCall";
    Intents["START_CHAT"] = "StartChat";
    Intents["VIEW_CONTACT"] = "ViewContact";
    Intents["VIEW_CHART"] = "ViewChart";
    Intents["VIEW_QUOTE"] = "ViewQuote";
    Intents["VIEW_NEWS"] = "ViewNews";
})(Intents = exports.Intents || (exports.Intents = {}));


/***/ })
/******/ ]);
});